import React from 'react';

/**
 * 
 * @param {Object} props Component props
 * @param {Number} props.size Set icon size, default is 30
 * @param {Function} props.onClick Executed function on clicked. If this props is defined, cursor will become 'pointer' when hovered.
 */

const hoverStyle = {
    cursor: 'pointer'
}

export const ViewIcon = props => (
    <img 
        src={`${process.env.PUBLIC_URL}/images/icon_view.png`}
        width={ props.size || "30" } 
        title="檢視" 
        alt="檢視" 
        onClick={props.onClick}
        style={props.onClick && hoverStyle}/>
);

export const EditIcon = props => (
    <img 
        src={`${process.env.PUBLIC_URL}/images/icon_edit.png`}
        width={ props.size || "30" } 
        title="編輯" 
        alt="編輯" 
        onClick={props.onClick}
        style={props.onClick && hoverStyle}/>
);

export const CorrectionsIcon = props => (
    <img 
        src={`${process.env.PUBLIC_URL}/images/icon_corrections.png`}
        width={ props.size || "30" } 
        title="補正" 
        alt="補正" 
        onClick={props.onClick}
        style={props.onClick && hoverStyle}/>
);

export const CancelIcon = props => (
    <img 
        src={`${process.env.PUBLIC_URL}/images/icon_cancel.png`}
        width={ props.size || "30" } 
        title="取消" 
        alt="取消" 
        onClick={props.onClick}
        style={props.onClick && hoverStyle}/>
);

export const PrintIcon = props => (
    <img 
        src={`${process.env.PUBLIC_URL}/images/icon_print.png`}
        width={ props.size || "30" } 
        title="列印" 
        alt="列印" 
        onClick={props.onClick}
        style={props.onClick && hoverStyle}/>
);

export const CopyIcon = props => (
    <img 
        src={`${process.env.PUBLIC_URL}/images/icon_copy.png`}
        width={ props.size || "30" } 
        title="複製" 
        alt="複製" 
        onClick={props.onClick}
        style={props.onClick && hoverStyle}/>
);

export const DeleteIcon = props => (
    <img 
        src={`${process.env.PUBLIC_URL}/images/icon_delete.png`}
        width={ props.size || "30" } 
        title={props.alt ? props.alt : "刪除"}
        alt={props.alt ? props.alt : "刪除"} 
        onClick={props.onClick}
        style={props.onClick && hoverStyle}/>
);

export const DownloadIcon = props => (
    <img 
        src={`${process.env.PUBLIC_URL}/images/icon_download.png`}
        width={ props.size || "30" } 
        title="下載" 
        alt="下載" 
        onClick={props.onClick}
        style={props.onClick && hoverStyle}/>
);

export const RevokeIcon = props => (
    <img 
        src={`${process.env.PUBLIC_URL}/images/icon_revoke.png`}
        width={ props.size || "30" } 
        title="抽回" 
        alt="抽回" 
        onClick={props.onClick}
        style={props.onClick && hoverStyle}/>
);

export const SetupIcon = props => (
    <img 
        src={`${process.env.PUBLIC_URL}/images/icon_setup.png`}
        width={ props.size || "30" } 
        title="設定" 
        alt="設定" 
        onClick={props.onClick}
        style={props.onClick && hoverStyle}/>
);

export const SelectIcon = props => (
    <img 
        src={`${process.env.PUBLIC_URL}/images/icon_select.png`}
        width={ props.size || "30" } 
        title="核可" 
        alt="核可" 
        onClick={props.onClick}
        style={props.onClick && hoverStyle}/>
);

export const PrompIcon = props => (
    <img 
        src={`${process.env.PUBLIC_URL}/images/icon_prompt.png`}
        width={ props.size || "30" } 
        title="問題說明" 
        alt="問題說明" 
        onClick={props.onClick}
        style={props.onClick && hoverStyle}/>
);



